<template>
    <div>
        <div class="content-box first" v-loading="dataLoading">
            <RsStep class="full" :active="2" :steps="['身份认证', '签署合同', '签署完成']"></RsStep>
            <el-result icon="success" title="已签署完成" subTitle="">
                <template slot="extra">
                    <el-button type="primary" @click="$router.push({ path: `/manage/album/list` })"
                        size="medium">下一步</el-button>
                </template>
            </el-result>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            resultCode: 0,
            dataLoading: false
        };
    },
    mounted() {
        this.updateUserInfo();
    },
    methods: {
        async updateUserInfo() {
            await this.$store.dispatch('getUserInfo'); // 更新用户状态
        }
    }
};
</script>

<style lang="scss" scoped></style>
